import React,{useState,useEffect} from "react";
import '../App.css';
import { AiFillStar } from "react-icons/ai";
import user from "../../assets/user2.png";
import google from "../../assets/google.png";
import { FaStar, FaStarHalfAlt, FaRegStar } from 'react-icons/fa';

function Second ({layout,testimonial,name,star,profile,highlight,colorTheme,time}){
  const [starsToShow, setStarsToShow] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [isValid, setIsValid] = useState(true);
  const [fade,setFade]=useState(false);
  const [words, setWords] = useState([]);
  const [commonWords, setCommonWords] = useState([]);

  useEffect(() => {
    const testimonialWords = testimonial && testimonial.trim().split(/\s+/);
    setWords(testimonialWords);
  
    // Flatten the array of strings into a single array of words
    const highlightWords = highlight && highlight.flatMap(str => str.split(/\s+/));
    
    const common = testimonialWords && testimonialWords.filter(word => highlightWords?.includes(word));
    setCommonWords(common);
  }, [testimonial, highlight]);   

  const renderHighlightedTestimonial = () => {
    return words&&words.map((word, index) => {
      if (commonWords.includes(word)) {
        return(
          <>
          {/* <span>&nbsp;</span> */}
          <span key={index} className="highlighted-text">{word}</span>
          <span>&nbsp;</span>
          </>
        ) ;
      } else {
        return <span key={index}>{word} </span>;
      }
    });
  }

  useEffect(()=>{
    setTimeout(() => {
      setFade(true)
    }, time-1000);
  })

  const handleImageError = () => {
    setIsValid(false);
  };
 
  useEffect(() => {
    let i = 0;
    const interval = setInterval(() => {
      if (testimonial && i < testimonial.length) {
        const currentChar = testimonial.charAt(i);
        setDisplayText(prevText => prevText + currentChar);
        i++;
      } else {
        clearInterval(interval);
        startStarAnimation();
      }
    }, 10);
  
    return () => clearInterval(interval);
  }, [testimonial]);
 
  const startStarAnimation = () => {
    const interval = setInterval(() => {
      setStarsToShow(prevStars => {
        if (prevStars < 5) {
          return prevStars + 1;
        } else {
          clearInterval(interval);
          return prevStars;
        }
      });
    }, 300);
  };  
return(
  layout === "Landscape"?(
    <div>
      <img onError={handleImageError}
        src={profile&&isValid?profile:user}
        width={80}
        className={`profile-img ${fade ? 'fade-out' : ''}`}
        style={{
          position: "absolute",
          zIndex: "9",
          top: "21vh",
          right: "21vw",
          border: "3px solid white",
          borderRadius: "50%",
          transition: "transform 1s ease-in-out"
        }}
      />
      <div
        className={`content-box ${fade ? 'close-book' : ''}`}
        style={{
          position: "absolute",
          right: "10vw",
          top: "27vh",
          background: "white",
          minHeight:"25vh",
          maxHeight:"65vh",
          width: "25vw",
          padding: "30px",
          borderRadius: "30px",
        }}
      >
         <img src={google} width={35} style={{ position:"absolute",top:"15px",right:"15px" }} />
        <p style={{color:colorTheme?colorTheme:"#703484",fontWeight:"600",fontSize:"2.2vw",margin:"6vh 0 2vh 0"}} className="animated-text">{name}</p>
        <div style={{display:"flex",gap:"1.5vw",justifyContent:"center"}}>
        {Array(5).fill().map((_, i) => {
            if (i < Math.floor(star)) {
              // Full stars
              return (
                <div key={i}>
                  <FaStar color="gold" size={25} className={i < starsToShow ? 'star animated' : 'star'}/>
                </div>
              );
            } else if (i === Math.floor(star) && !Number.isInteger(star)) {
              // Half star if the rating is not a whole number
              return (
                <div key={i}>
                  <FaStarHalfAlt color="gold" size={25} className={i < starsToShow ? 'star animated' : 'star'}/>
                </div>
              );
            } else {
              // Empty stars
              return (
                <div key={i}>
                  <FaRegStar color="gold" size={25} className={i < starsToShow ? 'star animated' : 'star'}/>
                </div>
              );
            }
            })
          }
        </div>
        {/* <p style={{color:"white",fontWeight:"600",fontSize:"1.2vw",marginTop:"0"}} className="animated-title">MOTION DESIGNER</p> */}
        <p style={{color:"black",fontWeight:"400",fontSize:"1.7vw"}} className="animated-first">{renderHighlightedTestimonial()}</p>
       
      </div>
      </div>
  ):(
    <div>
      <img onError={handleImageError}
        src={profile&&isValid?profile:user}
        width={80}
        className={`profile-img ${fade ? 'fade-out' : ''}`}
        style={{
          position: "absolute",
          zIndex: "9",
          top: "19vh",
          right: "31vw",
          border: "3px solid white",
          borderRadius: "50%",
          transition: "transform 1s ease-in-out",
          width:"12vw"
        }}
      />
      <div
        className={`content-box ${fade ? 'close-book' : ''}`}
        style={{
          position: "absolute",
          right: "10vw",
          top: "23vh",
          background: "white",
          minHeight:"25vh",
          maxHeight:"65vh",
          width: "50vw",
          padding: "30px",
          borderRadius: "30px",
        }}
      >
         <img src={google} width={35} style={{ position:"absolute",top:"15px",right:"15px" }} />
        <p style={{color:colorTheme?colorTheme:"#703484",fontWeight:"600",fontSize:"5vw",margin:"4vh 0 2vh 0"}} className="animated-text">{name}</p>
        <div style={{display:"flex",gap:"1.5vw",justifyContent:"center"}}>
        {Array(5).fill().map((_, i) => {
    if (i < Math.floor(star)) {
      return (
        <div key={i}>
          <FaStar color="gold" size={25}   className={i < starsToShow ? 'star animated' : 'star'}/>
        </div>
      );
    } else if (i === Math.floor(star)) {
      return (
        <div key={i}>
          <FaStarHalfAlt color="gold" size={25}   className={i < starsToShow ? 'star animated' : 'star'}/>
        </div>
      );
    } else {
      return (
        <div key={i}>
          <FaRegStar color="gold" size={25}   className={i < starsToShow ? 'star animated' : 'star'}/>
        </div>
      );
    }
  })}
        </div>
        {/* <p style={{color:"white",fontWeight:"600",fontSize:"1.2vw",marginTop:"0"}} className="animated-title">MOTION DESIGNER</p> */}
        <p style={{color:"black",fontWeight:"400",fontSize:"3vw"}} className="animated-first">{renderHighlightedTestimonial()}</p>
       
      </div>
      </div>
  )
)
}

export default Second;